module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/may/mainvisual-present@2x_791f89e7b0c81cd10d23aeafd24c4c87.png";